import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'entityMapperFilter'
})
export class EntityMapperFilterPipe implements PipeTransform {

  transform(items: any[], type: any, modules: any[], text: any, pipe: boolean): any {
    if (!items) return [];
    if (!text) {
      if (modules.length > 0) {
        // console.log("modules",modules);
        return items.filter((item) => (this.filterModule(item, modules) == true) && item.eType === type);
      } else {
        // console.log("modules11",modules);
        return items.filter((item) => item.eType === type);
      }
    } else {
      return items.filter((item) => {
        if (modules.length > 0) {
          if ((this.filterModule(item, modules) == true)  && item.eType === type) {
            return item.eName.toLocaleLowerCase().includes(text.toLocaleLowerCase());
          }
        } else {
          if (item.eType === type) {
            return item.eName.toLocaleLowerCase().includes(text.toLocaleLowerCase());
          }
        }
      });
    }
    // if (!items) return [];
    // if (!text) {
    //   return items.filter((item) => item.mID == modules.mID && item.eType == type);
    // }
    //  else if (modules != '' && text) {
    //   return items.filter((item) => {
    //     if (item.mID == modules.mID && item.eType == type) {
    //       return item.eName.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    //     }
    //   });
    // } 
    // else {
    //   return items.filter((item) => {
    //     if (item.eType == type) {
    //       return item;
    //     }
    //   });
    // }
    // return items.filter((item) => {
    //   // console.log('Personatype', this.filterPersona(item, Persona));
    //   if (item.eType == type && this.filterModule(item, modules) == true) {
    //     return item;
    //   }
    // });
  }
  filterModule(item: any, data: any) {
    if (data.length > 0) {
      if (data.indexOf(item.mID) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
}
